export class Version {

  static VERSION_DELIMITER = ".";

  // Is the given string a valid semantic version?
  // For example is it in the form of "1.2" or "1.2.3"?
  static isValid(versionString) {
    if (!versionString) return false;
    // This pattern matches simple semantic versions like 1.0.0, but it's basic and doesn't handle pre-release or build metadata
    const regex = /^\d+(\.\d+)*$/;
    return regex.test(versionString);
  }

  static getSegments(versionString) {
    return versionString.split(Version.VERSION_DELIMITER).map(Number);
  }

  static new(versionString) {
    if (!Version.isValid(versionString)) return null;
    return new Version(versionString);
  }

  constructor(versionString) {
    this.versionString = versionString;
    this.segments = Version.getSegments(this.versionString);
  }

  // Compares this version with another version string using semantic versioning rules
  compareTo(otherVersion) {
    const otherSegments = Version.getSegments(otherVersion);

    // Determine the maximum length to compare
    const maxLength = Math.max(this.segments.length, otherSegments.length);

    // Compare each segment
    for (let i = 0; i < maxLength; i++) {
      const thisSegment = this.segments[i] || 0;
      const otherSegment = otherSegments[i] || 0;

      if (thisSegment > otherSegment) {
        return 1; // this version is greater
      } else if (thisSegment < otherSegment) {
        return -1; // other version is greater
      }
    }

    // Versions are equal
    return 0;
  }

  // Helper methods for version comparisons
  isEqual(otherVersion) {
    return this.compareTo(otherVersion) === 0;
  }

  isGreaterThan(otherVersion) {
    return this.compareTo(otherVersion) > 0;
  }

  isGreaterThanOrEqual(otherVersion) {
    return this.compareTo(otherVersion) >= 0;
  }

  isLessThan(otherVersion) {
    return this.compareTo(otherVersion) < 0;
  }

  isLessThanOrEqual(otherVersion) {
    return this.compareTo(otherVersion) <= 0;
  }
}
